import { createSelector } from 'reselect'

const getUserData = state => state.user

const saveIconSelector = createSelector(
	[ getUserData ],
	userData => ({
		userId: userData.data.userId,
	})
)

export default saveIconSelector
